import { trackContact, trackLead } from '@/utils/fbPixel';

const WA_LINK = "https://wa.link/rb4jxv";

export default function CTAFinalSection() {
  return (
    <section className="bg-[#F7F7F7] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="border-3 border-[#E10600] rounded-2xl p-10 md:p-16 text-center" style={{ border: "3px solid #E10600" }}>
          <div className="w-16 h-16 flex items-center justify-center bg-[#E10600]/10 rounded-full mx-auto mb-6">
            <i className="ri-whatsapp-line text-[#E10600] text-3xl"></i>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black mb-4 leading-tight">
            Cotiza tu repuesto ahora mismo
          </h2>
          <p className="text-[#E10600] font-bold text-lg md:text-xl mb-8">
            Atención rápida y asesoría experta
          </p>
          <p className="text-gray-500 text-base mb-10 max-w-lg mx-auto">
            No pierdas más tiempo buscando. Nuestros expertos te ayudan a encontrar el repuesto exacto para tu Mitsubishi en minutos.
          </p>
          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            onClick={() => { trackContact(); trackLead(); }}
            className="inline-flex items-center gap-3 bg-[#E10600] hover:bg-red-700 text-white font-black text-lg md:text-xl px-10 py-5 rounded-full transition-all duration-200 hover:scale-105 shadow-lg shadow-red-200 whitespace-nowrap cursor-pointer animate-pulse-slow"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Escribir por WhatsApp
          </a>
          <p className="text-gray-400 text-xs mt-6">
            Lunes a Viernes 8:00 am - 5:00 pm &bull; Sábados 8:00 am - 12:00 pm
          </p>
        </div>
      </div>
    </section>
  );
}
